var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clock"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 12.5,
    cy: 13,
    r: 11.75,
    stroke: "#4A4A4A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1",
    d: "M12.75 6.5C12.75 6.08579 12.4142 5.75 12 5.75C11.5858 5.75 11.25 6.08579 11.25 6.5H12.75ZM11.25 6.5V13.5H12.75V6.5H11.25Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 2",
    d: "M16 17.5L11.9996 13.5",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
};
export default SvgClock;